import axios from 'axios'
import { Auth_Proto, Auth_Domain, Auth_Port } from '../Component/consts'

export let currentTenant
class NotificationService { 
  GetAllNotifications(tenantid,userid){
    return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/appmasters/getusernotifications/${tenantid}/${userid}`)
  }
   GetLastThreeandUnreadNotifications(tenantid,userid){
    return axios.get(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/appmasters/getlastthreeandunreadnotifications/${tenantid}/${userid}`)
  }
  NotificationsReadStatus(id){
    return axios.put(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/appmasters/updatenotestatus/${id}`)
  }
  MarkAllasRead(tenantid,userid){
    return axios.put(`${Auth_Proto}${Auth_Domain}${Auth_Port}/api/appmasters/markallnoteread/${tenantid}/${userid}`)
  }
}
export default new NotificationService();